<div class="m-content">
    <div class="m-portlet m-portlet--tab">
        <div class="m-portlet__head" *ngIf="editable">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <span class="m-portlet__head-icon m--hide">
						<i class="la la-gear"></i>
					</span>
                    <h3 class="m-portlet__head-text">
                        {{formLable}}
                    </h3>
                </div>
            </div>
        </div>

        <form class="m-portlet__body" *ngIf="editable" [formGroup]="formGroup">
            <div class="form-group m-form__group row">
                <span class="subtitle">{{inputLabel}}</span>
            </div>
            <div class="form-group m-form__group row">
                <label for="example-text-input" class="col-3 col-form-label">
					Location:
					<span *ngIf="options.required" class="red">*</span>
				</label>
                <div class="col-6">
                    <div class="row">
                        <div class="col-6">
                            <select class="form-control m-input m-input--square" formControlName="state" (change)="getDistricts()" [compareWith]="showSelected">
								<option disabled [value]="undefined" [selected]="true">Select State/UT</option>
								<option [ngValue]="state" *ngFor="let state of totalStates">{{state.name}}</option>
							</select>
                            <app-form-control-messages [control]="formGroup.get('state')" [name]="'State'"></app-form-control-messages>
                        </div>
                        <div class="col-6">
                            <select class="form-control m-input m-input--square" multiple [disabled]="disableDistricts" formControlName="districts" [compareWith]="showSelected">
								<option disabled [value]="undefined" [selected]="true">Select District</option>
								<option [ngValue]="dist" *ngFor="let dist of totalDistricts">{{dist ? dist.name : ''}}</option>
							</select>
                            <app-form-control-messages [control]="formGroup.get('districts')" [name]="'District'"></app-form-control-messages>
                        </div>
                    </div>
                </div>
            </div>
            <div class="alignCenter" *ngIf="options.add && (editStateRule === false)">
                <button class="btn btn-info" (click)="addValuesToTable()" [disabled]="formGroup.invalid || enableAddButton == false">Add</button>
            </div>
            <div class="alignCenter" *ngIf="options.edit &&  editStateRule === true">
                <button class="btn btn-info" (click)="updateStateRules()" [disabled]="formGroup.invalid || enableAddButton == false">update Rule</button>
                <button class="btn btn-info" (click)="updateStateRules()" [disabled]="formGroup.invalid || enableAddButton == false">cancel</button>
            </div>
        </form>
        <div *ngIf="rules.length <= 0 && selectStateError" class="color-error center-text">
            <p>
                State and districts is required.
            </p>
        </div>
        <hr>
        <div class="m-portlet__body">
            <div class="form-group m-form__group row">
                <span class="subtitle">{{tableLabel}}</span>
            </div>
            <div class="form-group m-form__group row table-align-resize">
                <table class="notranslate table table-striped m-table ">
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>State</th>
                            <th>District</th>
                            <th *ngIf="editDisable === false && editable">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of rules; let i = index">
                            <td>{{i + 1}}</td>
                            <td>{{data.state.name}}</td>
                            <td style="width:40%">
                                <span *ngFor="let selectedDistrict of data.districts let i = index">
								{{selectedDistrict.name}}
									<span *ngIf = "i != data.districts.length -1">
										,
									</span>
                                </span>

                            </td>
                            <td *ngIf="editable">
                                <ng-container *ngIf="options.edit">
                                    <span class="fa fa-trash link-text" (click)="deleteRow(i, data.state)">Delete</span>
                                    <!-- <span class="fa fa-trash" (click)="editRule(i, data)">Edit State</span> -->
                                </ng-container>

                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <hr>
    </div>
</div>